export default "__VITE_ASSET__CqBd7WZT__"